__turbopack_context__.v({
  "actions": "GlobalBanner-module__Vx5Svq__actions",
  "banner": "GlobalBanner-module__Vx5Svq__banner",
  "container": "GlobalBanner-module__Vx5Svq__container",
  "content": "GlobalBanner-module__Vx5Svq__content",
  "dismiss": "GlobalBanner-module__Vx5Svq__dismiss",
  "icon": "GlobalBanner-module__Vx5Svq__icon",
  "message": "GlobalBanner-module__Vx5Svq__message",
});
